import React, { useState } from "react";
import { useNavigate } from "react-router";
export default function AdminDashboardCard({
  title,
  loading,
  icon,
  hoverIcon,
  view,
  bgImage
}) {
  const navigate = useNavigate();
  const [imgIcon, setImgIcon] = useState(icon);
  return (
    <div
      onClick={()=>{
        if (view) {
          navigate(view);
        }
      }}
      onMouseOver={() => setImgIcon(hoverIcon)}
      onMouseOut={() => setImgIcon(icon)}
      className="admin-dashboard-card"
    >
      <div className="flex items-center gap-1">
        {imgIcon && <img src={imgIcon} alt={"image"} className=" transition-all duration-300 ease-in-out" width={45} height={45} />}
        <span className="text-[#3B3B3B] font-manrope font-[500] custom-md:text-[20px] text-[16px]">
          {title}
        </span>
      </div>
      {bgImage && (
      <div className="flex w-full">
        <img
          src={bgImage}
          alt={"bg-image"}
          className="ml-auto  float-right"
        />
      </div>
      )}
    </div>
  );
}
